<template>
  <section class="section container pt-5">
    <logs-datatable />
  </section>
</template>

<script>
import LogsDatatable from "./logs_datatable/Index.vue";

export default {
  name: "ScriptLog",
  components: { LogsDatatable },
  data() {
    return {
      is_loading: false,
    };
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {
      console.log("create order");
    },
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
